import * as React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

type DashboardCardProps = {
    title: React.ReactNode
    className?: string
    children: React.ReactNode
}

export default function DashboardCard({ title, className, children }: DashboardCardProps) {
    return (
        <Card className={cn('bg-white border border-border shadow-sm h-full flex flex-col', className)}>
            {title && <CardHeader className='pb-2'>
                <CardTitle className='text-base font-semibold'>{title}</CardTitle>
            </CardHeader>
            }
            <CardContent className='pt-0 flex-1'>
                {children}
            </CardContent>
        </Card>
    )
}


